import http from '../utils/http';
//
// get请求
export function getDictList(params) {
	return http.get(`/wx/open/dict/list`, params);
}
// 根据参数键名查询参数值
export function getConfigKey(configKey) {
	return http.get('/system/config/configKey/' + configKey);
}
// // post请求
// export function postFormAPI(params) {
//   return http.post(`${resquest}/postForm.json`, params);
// }
// 首页资讯列表
export function apiGetNewsList() {
	return http.get(`/index/phone/open/getNewsList1/20`);
}

// 首页免费视频
export function apiGetOpenPackageList(package_id) {
	return http.get(`/video/package/open/list/${package_id}`);
}
export function apiGetOpenClassList(package_id) {
	return http.get(`/video/package/open/class/list/${package_id}`);
}

// 首页评价
export function apiGetStudentComment() {
	return http.get(`/index/web/open/getStudentComment`);
}

export function apiGetGoodsList(title_type, goods_type) {
	return http.get(`/index/web/open/goodsList/${title_type}/${goods_type}`);
}

export function getParamDetail(config_key) {
	return http.get(`/common/getConfigInfo/${config_key}`);
}

//登录
export function apiLogin(data) {
	return http.post(`/app/login`, data);
}

export function apiForgetPhoneCode(phone_number) {
  return http.get(`/app/open/forget/phone/Code/${phone_number}`)
}

export function apiCheckFace(studentId) {
	return http.get(`/marking/student/checkFaced/${studentId}`);
}

export function apiGetHelpInfo(helpId) {
	return http.get(`/wx/open/get/help/detail/by/${helpId}`);
}

export function apiSetOnline(data) {
	return http.post(`/common/open/setOnline`, data);
}

export function apiGetCaptchaImage() {
	return http.get('/captchaImage');
}

export function apiGetRegisterCode(phone, uuid, code) {
	return http.get(`/wx/open/get/phone/Code/_secret/${phone}?uuid=${uuid}&code=${code}`);
}

export function apiRegister(data) {
	return http.post(`/app/register`, data);
}

// 登录设备列表
export function apiGetDevicesList() {
	return http.get(`/marking/student/devices/list`);
}

// 删除登录设备
export function apiDeleteDeviece(student_devices_id) {
	return http.post(`/marking/student/devices/delete/${student_devices_id}`);
}

// 获取消息列表
export function apiGetMessageList(params) {
	return http.post(`/message/user/list`, params);
}

// 获取消息详情
export function apiGetMessageDetail(messageId) {
	return http.get(`/message/user/detail/${messageId}`);
}

// 标记消息为已读
export function apiMarkMessageRead(messageId) {
	return http.put(`/message/user/read/${messageId}`);
}

// 删除消息
export function apiDeleteMessage(messageId) {
	return http.delete(`/message/deleteStudentMessage/${messageId}`);
}

// 获取未读消息数
export function apiGetUnreadCount() {
	return http.get(`/message/user/unreadCount`);
}

export function apiUpdateUserInfo(data) {
  return http.post(`/wx/update/current/user`, data)
}



// WEBPACK FOOTER //
// ./src/api/api.js